import { Button } from "antd";
import moment from "moment";
import React from "react";

import { statusLableColor } from "./statusLableColor";

import calendarCircle from "../../assets/icons/calendar-circle.svg";
import rightArrow from "../../assets/icons/arrow-right.svg";
import users from "../../assets/icons/profile-2user.svg";
import statusImg from "../../assets/icons/status.svg";

import "./styles.css";

export default function InsuranceItem({ insuranceData, setSelectedInsurance }) {
  const { name, patients_count, upload_date, status } = insuranceData;

  const { statusBackgroundColor, statusColor } = statusLableColor(status);

  return (
    <div className="insurance-item" onClick={() => setSelectedInsurance(insuranceData)}>
      <div className="insurance-name-after-break">
        <span className="treatment-name">{name}</span>

        {/* This button will be shown when the row layout breaks */}
        <ViewButton customClass="view-button-after-break" />
      </div>

      <div className="files-submission-status-container">
        <div className="insurance-labels-text file-label">
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={users} alt="patients" />
            <span style={{ color: "#848696" }}>Patients: </span>
          </div>

          <span>{patients_count}</span>
        </div>

        <div className="insurance-labels-text submission-label">
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={calendarCircle} alt="calendar-circle" />
            <span style={{ color: "#848696", textWrap: "nowrap" }}>Uploaded Date: </span>
          </div>

          <span style={{ minWidth: 100 }}>{upload_date ? moment(upload_date).format("DD/MM/YYYY") : "-"}</span>
        </div>

        <div className="insurance-labels-text status-label">
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <img src={statusImg} alt="insurance-status" />
            <span>Status: </span>
          </div>

          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: statusColor,
              padding: "1px 24px",
              borderRadius: 100,
              fontSize: 14,
              width: 123,
              textAlignc: "center",
              textTransform: "capitalize",
              textWrap: "nowrap",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {status}
          </span>
        </div>
      </div>

      {/* This button wont be shown after the layout breaks */}
      <ViewButton customClass="view-button-before-break" />
    </div>
  );
}

function ViewButton({ customClass }) {
  return (
    <div className={customClass}>
      <Button
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          fontSize: 16,
          border: "none",
          paddingRight: 0,
          paddingLeft: 0,
          color: "#6b43b5",
          marginLeft: "auto",
        }}
        // onClick={onClickFn}
      >
        <span>View </span>
        <img src={rightArrow} alt="view" />
      </Button>
    </div>
  );
}
